export default __webpack_public_path__ + "static/media/sanmar-logo.3bcb09e4.svg";